import { useEffect, useState } from "react";
import { Row, Col, message, Spin, Empty } from "antd";
import dayjs from "dayjs";
import { useSelector } from "react-redux";
import * as dashboardService from "../../../services/participantes/dashboardService";
import * as ubicacionesService from "../../../services/participantes/ubicacionesService";
import * as rolPromotoresService from "../../../services/participantes/rolPromotoresService";
import { selectAppPermissions } from "../../../store/auth/selectors";
import FiltrosDashboard from "./FiltrosDashboard";
import TotalesCards from "./TotalesCards";
import { ProgressChart } from "./ProgressChart";
import { UbicacionChart } from "./UbicacionChart";
import { LlamadasChart } from "./LlamadasChart";
import { DistribucionesChart } from "./DistribucionesChart";
import { RecentActivity } from "./RecentActivity";
import { IntentosValidacionChart } from "./IntentosValidacionChart";
export default function DashboardPage() {
  const [departamentoId, setDepartamentoId] = useState(null);
  const [municipioId, setMunicipioId] = useState(null);
  const [promotoresId, setPromotoresId] = useState(null);
  const [fechaInicio, setFechaInicio] = useState(null);
  const [fechaFin, setFechaFin] = useState(null);
  const [departamentos, setDepartamentos] = useState([]);
  const [municipios, setMunicipios] = useState([]);
  const [promotores, setPromotores] = useState([]);
  const [loadingPromotores, setLoadingPromotores] = useState(false);
  const [totales, setTotales] = useState(null);
  const [verDia, setVerDia] = useState([]);
  const [ubicacion, setUbicacion] = useState([]);
  const [llamadas, setLlamadas] = useState([]);
  const [distribuciones, setDistribuciones] = useState(null);
  const [actividad, setActividad] = useState([]);
  const [metricasLlamadas, setMetricasLlamadas] = useState({});
  const [tasaExito, setTasaExito] = useState({});
  const [promedioDia, setPromedioDia] = useState({});
  const [noVerificadosTotales, setNoVerificadosTotales] = useState({});
  const [intentosValidacion, setIntentosValidacion] = useState([]);
  const [efectividadIntentos, setEfectividadIntentos] = useState([]);
  const [exportData, setExportData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const appName = "dashboardparticipante";
  const permissions = useSelector((state) => selectAppPermissions(state, appName));
  const user = useSelector((state) => state.auth.user);
  const isAdmin = user?.priv_admin === true || user?.role === "1";
  const isRol2 = user?.role === "2";
  const isRol3 = user?.role === "3";
  const userLogin = user?.username;
  const permissionExport = permissions.priv_export === "Y";

  useEffect(() => {
    if (isRol2 && user?.cod_municipio) {
      setMunicipioId(user.cod_municipio);
    }
  }, [isRol2, user]);

  useEffect(() => {
    const loadPromotoresRol2 = async () => {
      if (isRol2 && user?.cod_municipio) {
        try {
          setLoadingPromotores(true);
          const res = await rolPromotoresService.getPromotoresByMunicipio(user.cod_municipio);
          setPromotores(res.data || []);
        } catch (error) {
          console.error("Error cargando promotores rol 2:", error);
          setPromotores([]);
        } finally {
          setLoadingPromotores(false);
        }
      }
    };

    loadPromotoresRol2();
  }, [isRol2, user]);

  useEffect(() => {
    async function loadDeptos() {
      try {
        const res = await ubicacionesService.getDepartamentos(2);
        setDepartamentos(res.data || []);
      } catch (error) {
        console.error("Error cargando departamentos:", error);
        message.error("Error al cargar departamentos");
      }
    }
    loadDeptos();
  }, []);

  const onSelectMunicipio = async (value) => {
    setMunicipioId(value);
    setPromotoresId(null);

    if (!value) {
      setPromotores([]);
      return;
    }

    try {
      setLoadingPromotores(true);
      const res = await rolPromotoresService.getPromotoresByMunicipio(value);
      setPromotores(res.data || []);
    } catch (error) {
      console.error("Error cargando promotores:", error);
      message.error("Error al cargar promotores");
      setPromotores([]);
    } finally {
      setLoadingPromotores(false);
    }
  };


  const onSelectDepto = async (value) => {
    setDepartamentoId(value);
    setMunicipioId(null);
    setPromotoresId(null);
    setPromotores([]);
    if (!value) {
      setMunicipios([]);
      return;
    }
    try {
      const res = await ubicacionesService.getMunicipios(value, 2);
      setMunicipios(res.data || []);
    } catch (error) {
      console.error("Error cargando municipios:", error);
      message.error("Error al cargar municipios");
      setMunicipios([]);
    }
  };


function limpiarFiltros() {
  setLoading(true); 
  if (isAdmin) {
    setDepartamentoId(null);
    setMunicipioId(null);
    setMunicipios([]);
    setPromotores([]);
  }
  if (isRol2 && user?.cod_municipio) {
    setMunicipioId(user?.cod_municipio);
  }
  setPromotoresId(null);
  setFechaInicio(null);
  setFechaFin(null);
}




const getCurrentFilters = () => {
  return {
    userLogin,
    ...(departamentoId && { departamentoId }),
    ...(isRol2
        ? { municipioId: user?.cod_municipio }
        : municipioId && { municipioId }
    ),
    ...(promotoresId && { promotoresId }),
    ...(fechaInicio && { fechaInicio: dayjs(fechaInicio).format("YYYY-MM-DD") }),
    ...(fechaFin && { fechaFin: dayjs(fechaFin).format("YYYY-MM-DD") }),
  };
};


  async function cargarDashboard() {
    const filtros = getCurrentFilters();
    if (filtros.fechaInicio && filtros.fechaFin) {
      const inicio = dayjs(filtros.fechaInicio);
      const fin = dayjs(filtros.fechaFin);
      if (fin.isBefore(inicio)) {
        message.error("La fecha fin no puede ser anterior a la fecha inicio");
        return;
      }
      const diasDiferencia = fin.diff(inicio, 'day');
      if (diasDiferencia > 90) {
        message.warning("El rango de fechas no debe exceder los 90 días para mejor performance");
      }
    }
    try {
      setLoading(true);
      setError(null);
      const [
        t, v, u, l, d, a, ml, te, pd,
        nv, iv, ef, ex
      ] = await Promise.all([
        dashboardService.getTotales(filtros),
        dashboardService.getVerificacionDiaria(filtros),
        dashboardService.getPorUbicacion(filtros),
        dashboardService.getLlamadas(filtros),
        dashboardService.getDistribuciones(filtros),
        dashboardService.getActividadReciente(filtros),
        dashboardService.getMetricasLlamadas(filtros),
        dashboardService.getTasaExito(filtros),
        dashboardService.getPromedioLlamadasDia(filtros),
        dashboardService.getNoVerificadosTotales(filtros),
        dashboardService.getIntentosValidacion(filtros),
        dashboardService.getEfectividadPorIntentos(filtros),
        dashboardService.getExportData(filtros),
      ]);
      if (t.data?.success !== false) {
        const totalesData = t.data.data ?? t.data;
        setTotales({
          totalParticipantes: totalesData.totalParticipantes ?? 0,
          hombresTotales: totalesData.hombresTotales ?? 0,
          mujeresTotales: totalesData.mujeresTotales ?? 0,
          totalContactados: totalesData.totalContactados ?? 0,
          hombresContactados: totalesData.hombresContactados ?? 0,
          mujeresContactadas: totalesData.mujeresContactadas ?? 0,
          verificados: totalesData.verificados ?? 0,
          enProceso: totalesData.enProceso ?? 0,
          noContinua: totalesData.noContinua ?? 0,
          noVerificados: totalesData.noVerificados ?? 0,
          llamadasRealizadas: totalesData.llamadasRealizadas ?? 0,
        });
      } else {
        setTotales({
          totalParticipantes: 0,
          hombresTotales: 0,
          mujeresTotales: 0,
          totalContactados: 0,
          hombresContactados: 0,
          mujeresContactadas: 0,
          verificados: 0,
          enProceso: 0,
          noContinua: 0,
          noVerificados: 0,
          llamadasRealizadas: 0,
        });
      }
      if (v.data && v.data.success !== false) {
        setVerDia(v.data.data || []);
      } else {
        setVerDia([]);
      }
      if (u.data && u.data.success !== false) {
        setUbicacion(u.data.data || []);
      } else {
        setUbicacion([]);
      }
      if (l.data && l.data.success !== false) {
        setLlamadas(l.data.data?.llamadasPorDia || l.data.llamadasPorDia || []);
      } else {
        setLlamadas([]);
      }
      if (d.data && d.data.success !== false) {
        setDistribuciones(d.data.data || d.data);
      } else {
        setDistribuciones(null);
      }
      if (a.data && a.data.success !== false) {
        setActividad(a.data.data || []);
      } else {
        setActividad([]);
      }
      if (ml.data && ml.data.success !== false) {
        setMetricasLlamadas(ml.data.data || {});
      } else {
        setMetricasLlamadas({});
      }
      if (te.data && te.data.success !== false) {
        setTasaExito(te.data.data || {});
      } else {
        setTasaExito({});
      }
      if (pd.data && pd.data.success !== false) {
        setPromedioDia(pd.data.data || {});
      } else {
        setPromedioDia({});
      }
      if (nv.data && nv.data.success !== false) {
        setNoVerificadosTotales(nv.data.data || {});
      } else {
        setNoVerificadosTotales({});
      }
      if (iv.data && iv.data.success !== false) {
        setIntentosValidacion(iv.data.data || []);
      } else {
        setIntentosValidacion([]);
      }
      if (ef.data && ef.data.success !== false) {
        setEfectividadIntentos(ef.data.data || []);
      } else {
        setEfectividadIntentos([]);
      }
      if (ex.data && ex.data.success !== false) {
        setExportData(ex.data.data || ex.data);
      } else {
        setExportData(null);
      }
    } catch (err) {
      console.error("Error dashboard:", err);
      setError(err.message || "Error al cargar datos del dashboard");
      message.error("Error al cargar datos del dashboard");
      setTotales(null);
      setVerDia([]);
      setUbicacion([]);
      setLlamadas([]);
      setDistribuciones(null);
      setActividad([]);
      setMetricasLlamadas({});
      setTasaExito({});
      setPromedioDia({});
      setNoVerificadosTotales({});
      setIntentosValidacion([]);
      setEfectividadIntentos([]);
      setExportData(null);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    cargarDashboard();
  }, []);

  useEffect(() => {
    cargarDashboard();
  }, [departamentoId, municipioId, promotoresId, fechaInicio, fechaFin]);

  const renderContent = () => {
    if (loading) {
      return (
        <div style={{ textAlign: 'center', padding: '50px' }}>
          <Spin size="large" />
          <p>Cargando datos del dashboard...</p>
        </div>
      );
    }

    if (error) {
      return (
        <div style={{ textAlign: 'center', padding: '50px' }}>
          <Empty
            image={Empty.PRESENTED_IMAGE_SIMPLE}
            description={
              <div>
                <p style={{ color: '#ff4d4f' }}>{error}</p>
                <p>Por favor, intenta con otros filtros o recarga la página</p>
              </div>
            }
          />
        </div>
      );
    }

    const hasData = totales?.totalParticipantes > 0
      || actividad.length > 0
      || llamadas.length > 0;

    if (!hasData) {
      return (
        <div style={{ textAlign: 'center', padding: '50px' }}>
          <Empty
            description={
              <div>
                <p>No hay registros para los filtros seleccionados</p>
                <p>Intenta con un rango de fechas diferente o sin filtros</p>
              </div>
            }
          />
        </div>
      );
    }

    return (
      <>
        <TotalesCards
          totales={totales}
          metricasLlamadas={metricasLlamadas}
          tasaExito={tasaExito}
          promedioDia={promedioDia}
          noVerificadosTotales={noVerificadosTotales}
          loading={loading}
        />
        <br />
        <Row gutter={[16, 16]}>
          <Col xs={24} lg={12}>
            <ProgressChart data={verDia} />
          </Col>
          <Col xs={24} lg={12}>
            <UbicacionChart data={ubicacion} />
          </Col>
          <Col xs={24} lg={12}>
            <LlamadasChart data={llamadas} />
          </Col>
          <Col xs={24} lg={12}>
            {distribuciones && (
              <DistribucionesChart
                data={distribuciones}
                filters={getCurrentFilters()}
              />
            )}
          </Col>
          <Col xs={24} lg={12}>
            <IntentosValidacionChart
              data={intentosValidacion}
              efectividadData={efectividadIntentos}
            />
          </Col>
          <Col xs={24} lg={12}>
            <RecentActivity data={actividad} />
          </Col>
        </Row>
      </>
    );
  };

  return (
    <div style={{ padding: 20 }}>

      {!isRol3 && (
        <FiltrosDashboard
          departamentoId={departamentoId}
          municipioId={municipioId}
          promotoresId={promotoresId}
          promotores={promotores}
          loadingPromotores={loadingPromotores}
          fechaInicio={fechaInicio}
          fechaFin={fechaFin}
          departamentos={departamentos}
          municipios={municipios}
          onSelectDepto={onSelectDepto}
          onSelectMunicipio={onSelectMunicipio}
          setPromotoresId={setPromotoresId}
          setFechaInicio={setFechaInicio}
          setFechaFin={setFechaFin}
          limpiarFiltros={limpiarFiltros}
          exportData={exportData}
          loading={loading}
          permissionExport={permissionExport}
          isAdmin={isAdmin}
          isRol2={isRol2}
        />
      )}

      {renderContent()}
    </div>
  );

}